const graphics = {
    title: String("Gràfics"),
    graphicsManagerTitle: String("Gestió dels gràfics"),
    batteryChartTitle: String("Tensió de la bateria (V)"),
    temperatureChartTitle: String("Temperatura (ºC) i Humitat Relativa (%)"),
    leafHumidityChartTitle: String("Humitat en fulla (mV)"),
    rainmeterChartTitle: String("Pluviometria (L)"),
    flowmeterChartTitle: String("Caudalimetre (L/m3)"),
    rainAndFlowChartTitle: String("Pluviometria (L) i Caudalimetre (L/m3)"),
    soilMoistureChartTitle: String("Sondes d'humitat del sòl"),
    selectorPlaceholder: String("Llista d'estacions"),
    generateChartsButton: String("Generar gràfics"),
    fetchingDataButton: String("Generant"),
    fetchingDataMessage: String("Els gràfics s'estan generant. Espera un moment"),
    largeDataAdviseMessage: String("Per periodes llargs aquest procés pot trigar alguns minuts"),
    noModulesAvailable: String("No hi ha cap estació disponible"),
    fetchingNotFoundMessage: String("No s'han trobat dades de l'estació en el rang de dates seleccionat."),
    noDataSelected: String("No s'ha seleccionat cap dada."),
    accumulatedRainLabel: String("Pluja acumulada"),
    accumulatedFlowLabel: String("Reg acumulat"),
    generateReport: String("Generar informe"),
    temperatureDropdownItem: String("Temperatura i Humitat Relativa"),
    leafHumidityDropdownItem: String("Humitat en fulla"),
    rainAndFlowDropdownItem: String("Pluviometria i Caudalimetre"),
    soilMoistureDropdownItem: String("Sondes d'humitat del sòl"),
    dropdownAnalysisOption: String("Analisis del reg"),
    downloadDataset: String("Descarregar dades"),
    download: String("Descarregar"),
    moduleName: String("Nom Estació"),
    moduleId: String("Codi Estació"),
    modulePeriod: String("Període"),
    //Modal
    generatingReport: String("Generant informe"),
    genTempHumChartMsg: String("Exportant gràfic de temperatura i humitat"),
    genLeafHumChartMsg: String("Exportant gràfic de humitat en fulla"),
    genSoilChartMsg: String("Exportant gràfic de humitat en sòl"),
    genRainFlowChartMsg: String("Exportant gràfic de pluviometria i caudalímetre"),
    genPDFMsg: String("Generant informe en PDF"),
    genDownloadingPDFMsg: String("Descarregant informe"),

    legendWaterNotAvailable:    String('Aigua no disponible'),
    legendWaterAvailable:       String('Aigua disponible'),
    legendWaterEasyAvailable:   String('Aigua fàcilment disponible'),
}
export default graphics;
